import { render, staticRenderFns } from "./CommonDocumentChip.vue?vue&type=template&id=3ba4401c"
import script from "./CommonDocumentChip.vue?vue&type=script&lang=js"
export * from "./CommonDocumentChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports